import React, { useContext, useEffect, useState } from 'react';
import { ConfigValues } from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context/ApplicationContext';
import {
  generateHeaderScript,
  generateMessagingCodeSnippet
} from '@MerchantConfigurator/utils/messaging';
import PropTypes from 'prop-types';
import { LoadingSpinner } from '@paypalcorp/pp-react';
import styles from './PreviewControls.module.less';

const MessagingIFrame = ({ messageConfig, offerType, productPrice = '89.99', darkMode }) => {
  const { bnCode, localeConfig } = useContext(ApplicationContext);
  const { clientId, currency, countryCode: country } = localeConfig;
  const [isLoading, setIsLoading] = useState(true);

  const headerScript = generateHeaderScript({
    bnCode,
    clientId,
    country,
    currency
  });

  // The generateMessagingCodeSnippet returns nothing when a config is not enabled
  // to make sure that the messaging script is not injected to placements the merchant
  // has not turned on.  However to show the preview, we must always override it to enabled
  const enabledMessageConfig = {
    ...messageConfig,
    status: ConfigValues.status.enabled
  };

  const messagingCodeSnippet = generateMessagingCodeSnippet({
    messageConfig: enabledMessageConfig,
    offerType,
    productPrice
  });

  const messageContent = `<!DOCTYPE html>
    <html>
        <head>
            ${headerScript.trim()}
        </head>
        <body style='margin: 0'>
            <div>
                ${messagingCodeSnippet.trim()}
            </div>
        </body>
    </html>`;

  useEffect(() => {
    setIsLoading(true);
  }, [messageContent]);

  return messageContent ? (
    <>
      {isLoading && (
        <div className={styles.iframe_loading_spinner}>
          <LoadingSpinner inverse={darkMode} />
        </div>
      )}
      <iframe
        css={{
          zoom: 0.9,
          MozTransform: 'scale(0.9)',
          MozTransformOrigin: '0 0',
          OTransform: 'scale(0.9)',
          OTransformOrigin: '0 0',
          WebkitTransform: 'scale(0.9)',
          WebkitTransformOrigin: ' 0 0'
        }}
        style={{ transform: 'scale(0.9)', transformOrigin: '0 0' }}
        srcDoc={messageContent}
        width="100%"
        height="100%"
        frameBorder="0"
        onLoad={() => setIsLoading(false)}
      />
    </>
  ) : (
    <></>
  );
};

export default MessagingIFrame;

MessagingIFrame.propTypes = {
  messageConfig: PropTypes.object,
  offerType: PropTypes.string,
  productPrice: PropTypes.string
};
